import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, PagingResponseModel, ApiVisa, Pagination, BasicApiResponseModel} from '../../shared';
import {MembershipConfigContainerModel} from '../../../../../../models/aggregates/crm/membership-config';
import {Core2Config} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class MembershipConfigService extends BaseApiTemplateService<MembershipConfigContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-configs/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL +  Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-configs/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-configs/backoffice-ep';
    this.httpClient = http;
  }

}


